import {deepClone, getUrlParams, StorageUtils} from "xmgoing-utils";
import {getDetailByPageId, saveColsConfig} from "@/main-page/ctlServerApi/gridCtlServer";
import GoingUtils from "@/utils/goingUtils";
import {columnForPersist} from "@/main-page/commonVue/hooks/useColFilterHooks";

/**
 * 获取当前表格id
 * @param props
 */
export const getTableCtlId = function (props) {
  return GoingUtils.getPageCode() + unref(props).key
}

/**
 * 获取当前表格列缓存信息
 * @param props
 */
export const getCacheTableId = function (props) {
  return getTableCtlId(props) + "ColumnsConfig";
}

/**
 *
 * @param columns
 * @param props
 */
export const saveUserColDataFun = function (columns, props, backFun?: any, failFun?: any) {
  const source = unref(columns);
  // 多列排序时列上的 sorter 是临时的，保存前换回原来的排序开关
  const persistColumns = Array.isArray(source) ? source.map((column) => columnForPersist(column)) : source;
  let JsonShowField: any = deepClone(persistColumns);
  const data = {
    pageId: getTableCtlId(props),
    searchField: JSON.stringify(""),
    showField: !JsonShowField ? "" : JSON.stringify(JsonShowField),
    sortField: "",
  };
  saveColsConfig(data, (res) => {
    StorageUtils.removeSessionItem(getCacheTableId(props));
    backFun && backFun(res);
  }, failFun);
}

/**
 * 按表格身份键读取个人列配置（可供非 useColSaveHooks 场景复用，如关联表单选择弹窗）
 */
export const initColSByDbColStandalone = async function (
  props,
  backFun,
  userFieldConfigCols?,
  subGridKey?,
  mainPageColConfigCode?
) {
  const dbColMap = {};
  let delivered = false;
  const notify = (map, colSot, requestFailed = false) => {
    if (delivered) {
      return;
    }
    delivered = true;
    try {
      backFun && backFun(map, colSot, requestFailed);
    } catch (callbackError) {
      console.error(callbackError);
    }
  };
  try {
    const colConfigsDb: any = await getDetailByPageId(
      {pageId: getTableCtlId(props)},
      userFieldConfigCols,
      subGridKey,
      mainPageColConfigCode
    );
    if (colConfigsDb && colConfigsDb['showField']) {
      try {
        StorageUtils.addSessionItem(getCacheTableId(props), JSON.stringify(colConfigsDb));
      } catch (e) {
        console.error(e, JSON.stringify(colConfigsDb) + "-----addSessionItem------")
      }
      if (typeof (colConfigsDb['showField']) === 'string') {
        colConfigsDb.showField = JSON.parse(colConfigsDb.showField);
      }
      const colSot = {};
      if ((colConfigsDb.isNew + '') !== "true") {
        colConfigsDb.showField.forEach((itemDb, index) => {
          colSot[itemDb.propId] = index;
        })
      }

      const showFiled = colConfigsDb.showField;
      if (showFiled && Array.isArray(showFiled)) {
        showFiled.forEach((fieldItem) => {
          if (fieldItem.propWidth !== fieldItem.width) {
            fieldItem.propWidth = fieldItem.width;
          }
          unref(dbColMap)[fieldItem['dataIndex'] || fieldItem['propId']] = fieldItem;
        })
      }
      notify(unref(dbColMap), colSot);
    } else {
      notify({});
    }
  } catch (e) {
    console.error(e);
    // 请求失败和「没有保存过列配置」分开。失败不记成进入页面时的列配置。
    notify({}, undefined, true);
  }
}

export function useColSaveHooks({props, columns}) {
  let timer: any = null;

  /**
   * 保存数据
   */
  const saveData = function (columns, backFun?: any, failFun?: any) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(async () => {
      saveUserColDataFun(columns, props, backFun, failFun);
    }, 150);
  }

  const initColSByDbCol = async function (backFun, userFieldConfigCols,subGridKey,mainPageColConfigCode) {
    return initColSByDbColStandalone(props, backFun, userFieldConfigCols, subGridKey, mainPageColConfigCode);
  }

  /**
   * 处理列宽度设置
   */
  const handleResizeColumn = async function ({columnsInfo, colInfo}: any) {
    try {
      const colConfigsDb: any = await getDetailByPageId({pageId: getTableCtlId(props)});

      if (colConfigsDb && colConfigsDb['showField']) {
        colConfigsDb.showField = JSON.parse(colConfigsDb.showField);
      }
      const dbColMap = {};
      //获取数据库配置的列信息
      if (columnsInfo && Array.isArray(columnsInfo)) {
        columnsInfo.forEach((fieldItem) => {
          unref(dbColMap)[fieldItem['dataIndex'] || fieldItem['propId']] = fieldItem;
        })
      }
      /**
       * 循环 对部分属性需要进行合并
       */
      colConfigsDb.showField.forEach((colItem) => {
        const dbItem = unref(dbColMap)[colItem['dataIndex'] || colItem['propId']];
        if (dbItem) {
          colItem.width = dbItem.width;
        }
      })
      saveData(colConfigsDb.showField);
    } catch (e) {
      saveData(columnsInfo);
    }
  }
  /**
   * 列显示设置
   */
  const columnsSave = function () {
    // 去重
    const dataIndexMap = new Set();
    const currentInit: any = [];
    for (let i = 0; i < unref(columns).length; i++) {
      const {dataIndex} = unref(columns)[i];
      if (!dataIndexMap.has(dataIndex)) {
        dataIndexMap.add(dataIndex);
        currentInit.push(unref(columns)[i]);
      }
    }
    saveData(currentInit);
  }

  return {
    saveData,
    handleResizeColumn,
    initColSByDbCol,
    columnsSave
  }
}
